import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import IconBtn from "./IconBtn/IconBtn";

export default function ExportExcel(props) {
  const handleExport = () => {
    if (!props.dataToExport || props.dataToExport.length === 0) {
      return;
    }

    // Créer un nouveau workbook
    const workbook = XLSX.utils.book_new();

    // Pour chaque feuille de données
    props.dataToExport.forEach((sheet) => {
      // Préparer les données avec les en-têtes
      const worksheetData = [
        sheet.sheetHeader, // Première ligne = en-têtes
        ...sheet.sheetData.map((row) => {
          // Pour chaque ligne, créer un tableau avec les valeurs dans l'ordre des en-têtes
          return sheet.sheetHeader.map((header) => row[header] || "");
        })
      ];

      // Créer la feuille de calcul
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      
      // Ajouter la feuille au workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, sheet.sheetName);
    });

    // Générer le fichier Excel
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    
    // Télécharger le fichier
    saveAs(data, `${props.fileName || "export"}.xlsx`);
    
    // Appeler le callback
    if (props.callBack) {
      props.callBack();
    }
  };

  return (
    <IconBtn
      label="Télécharger"
      icon="download"
      handleClick={handleExport}
    />
  );
}
